export const sendEventToGA = (eventName: string): void => {
  if ((window as any).dataLayer) {
    (window as any).dataLayer.push({
      event: eventName,
    });
  } else {
    console.log("datalayer not defined, event will not be saved");
  }
};
